import type { Tracker } from "@/src/features/api/TrackerApi";

export const isQuietTracker = (item: Tracker): boolean =>
  item.status === "ACTIVE" && Number(item.unread_count ?? 0) <= 0;

export const getQuietTrackerCount = (
  fullRows: Tracker[],
  unreadRowsByWatermark: Tracker[],
): number => {
  const activeFullRows = fullRows.filter((item) => item.status === "ACTIVE");
  const unreadActiveTrackerIds = new Set(
    unreadRowsByWatermark
      .filter((item) => item.status === "ACTIVE")
      .map((item) => item.tracker_id ?? ""),
  );

  return activeFullRows.filter(
    (item) => !unreadActiveTrackerIds.has(item.tracker_id ?? ""),
  ).length;
};
